// @mui
// #region IMPORT
import { Stack, Avatar, Typography } from '@mui/material';

import { Iconify, APP_ICONS } from 'src/components/iconify';

import type { ITestimonialProps } from './testimonial-elearning';
// #endregion
// types
// components

// ----------------------------------------------------------------------
// #region INTERFACE
export type TestimonialItemContentProps = {
  testimonial: ITestimonialProps;
};
// #endregion

export function TestimonialItemContent({ testimonial }: TestimonialItemContentProps) {
  const { review } = testimonial;

  return (
    <Stack alignItems="center">
      <Iconify
        icon={APP_ICONS.editor.quotes}
        sx={{ width: 48, height: 48, opacity: 0.48, color: '#FA541C' }}
      />

      <Typography
        variant="body1"
        sx={{
          mt: 2,
          mb: 5,
        }}
      >
        {review}
      </Typography>
    </Stack>
  );
}

// ----------------------------------------------------------------------

type TestimonialItemThumbnailProps = {
  testimonial: ITestimonialProps;
  isSelected: boolean;
};

export function TestimonialItemThumbnail({
  testimonial,
  isSelected,
}: TestimonialItemThumbnailProps) {
  const { avatar, name } = testimonial;

  return (
    <Stack
      sx={{
        width: 96,
        height: 96,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Avatar
        src={avatar}
        alt={name}
        sx={{
          width: 48,
          height: 48,
          opacity: 0.48,
          cursor: 'pointer',
          transition: (theme) => theme.transitions.create('all'),
          ...(isSelected && {
            opacity: 1,
            transform: 'scale(2)',
          }),
        }}
      />
    </Stack>
  );
}
